import React, { useContext, useMemo } from 'react';
import queryString from 'query-string';
import API from '../utils/api';
import SigninContext from '../contexts/SigninContext';
import SigninFlow from '../components/signin/SigninFlow';

import {
    API_IDENTIFICATION_STREETEASY_OAUTH_FUNC,
    STREETEASY_OAUTH_REDIRECT_URL,
} from '../constants/ApiConstants';
import { withRouter } from 'react-router-dom';

const StreetEasyOAuthPage = ({ location }) => {
    const code = queryString.parse(location.search)['code'] || null;

    const {
        state: { csrfToken },
    } = useContext(SigninContext);

    const signinPromise = useMemo(
        () =>
            API({
                method: 'post',
                url: API_IDENTIFICATION_STREETEASY_OAUTH_FUNC({
                    authorizationCode: code,
                    redirectUrl: STREETEASY_OAUTH_REDIRECT_URL,
                }),
                headers: {
                    'X-Csrf-Token': csrfToken,
                },
            }),
        [code, csrfToken]
    );

    return useMemo(() => <SigninFlow signinPromise={signinPromise} />, [signinPromise]);
};

export default withRouter(StreetEasyOAuthPage);
